import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { GlobalService, IGlobalServiceListener } from '../global.service';
import { Global } from '../classes/Global';
import { DateHelper } from '../helpers/DateHelper';
import { Router } from '@angular/router';
import { StorageHelper } from "../helpers/StorageHelper";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent extends BaseComponent implements OnInit, OnDestroy, IGlobalServiceListener {

  newCardDealChange(value: boolean) {
    this.newCardDeal = value;
  }

  newCardDeal: boolean;

  constructor(
    private globalService: GlobalService,
    private router: Router,
  ) {
    super();
  }

  hasNewCardDeal(): boolean {
    if (!!StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)) {
      return this.newCardDeal;
    }
    return false;
  }

  ngOnInit() {
    this.globalService.subscribe(this);
  }

  ngOnDestroy(){
    this.globalService.unsubscribe(this);
  }

  getMediaType(): string {
    return Global.getMediaTypeForUrl();
  }

  getStoreUrl(): string {
    return Global.getStoreUrl();
  }

  getListsUrl(): string {
    return "/" + Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + this.getString("wishlistUrl");
  }

  getDiscoverUrl(): string {
    return "/" + [
      Global.getCountry(),
      Global.getStoreUrl(),
      Global.getMediaTypeForUrl(),
      this.getString("discoverUrl"),
      this.getString("editorialListsUrl")
    ].join("/");
  }

  isPersonalListsRouteActive(): boolean {
    return this.isRouteActive(this.getString("wishlistUrl")) ||
      this.isRouteActive(this.getString("myPurchasesUrl")) ||
      this.isRouteActive(this.getString("myListsUrl")) ||
      this.isRouteActive(this.getString("blocklistUrl"));
  }

  isPublicListsRouteActive(): boolean {
    return this.hasRouteSegment(this.getString("publicListsUrl")) ||
      this.hasRouteSegment(this.getString("communityListsUrl")) ||
      this.hasRouteSegment(this.getString("discoverUrl")) ||
      this.hasRouteSegment(this.getString("listsUrl"));
  }

  hasRouteSegment(segment: string): boolean {
    const path = location ? location.pathname.toString() : "";
    if (!path || !segment) {
      return false;
    }
    const routeSegments = path.split("/").filter((part) => part !== "");
    return routeSegments.indexOf(segment) > -1;
  }

  isBlackFriday() {
    return DateHelper.isBlackFriday();
  }

  searchClicked(obj){
    if (obj && obj.itemType != "" && obj.query != "") {
      this.router.navigate([ "/" + Global.getCountry() + "/search", { q: encodeURIComponent(obj.query), t: obj.itemType}]);
    }
  }

}
